// useAddressAutocomplete.ts
import { loadGooglePlaces } from '@/utils/googlePlaces';

interface AddressForm {
    address1: string;
    postalcode: string;
    city: string;
    country: string;
}

const componentMapping: Record<string, keyof AddressForm> = {
    street_number: 'address1',
    route: 'address1',
    postal_code: 'postalcode',
    locality: 'city',
    postal_town: 'city', // fallback
    country: 'country',
};

export function useAddressAutocomplete(
    inputId: string,
    form: AddressForm,
    countryList: { code: string; name: string }[]
) {
    function init() {
        loadGooglePlaces(() => {
            const el = document.getElementById(inputId) as HTMLInputElement;
            if (!el || !window.google) return;

            const autocomplete = new google.maps.places.Autocomplete(el, {
                types: ['address'],
                componentRestrictions: { country: countryList.map(c => c.code as any) },
            });

            autocomplete.addListener('place_changed', () => {
                const place = autocomplete.getPlace();
                const comps = place.address_components || [];

                // temp storage for street parts
                let streetNumber = '';
                let route = '';

                comps.forEach(c => {
                    const type = c.types[0];
                    const field = componentMapping[type];
                    if (!field) return;

                    const value = type === 'country'
                        ? c.short_name
                        : c.long_name;

                    if (type === 'street_number') {
                        streetNumber = c.long_name;
                    } else if (type === 'route') {
                        route = c.long_name;
                    } else {
                        form[field] = value;
                    }
                });

                // build full street address
                if (route) {
                    form.address1 = streetNumber ? `${route} ${streetNumber}` : route;
                }
            });
        });
    }

    return { init };
}
